<p>invoice-status-graph works!</p>
